// ヘッダーの「メニュー」ボタンで、開閉メニューの表示切り替え＋ボタンラベルの出し分け
const headerNavToggle = document.querySelector( ".js-header-nav-toggle" );
const headerOpenNav = document.querySelector( ".js-header-open-nav" );
const headerNavToggleLabel = document.querySelector( ".js-header-nav-toggle-label" );

if ( headerNavToggle && headerOpenNav )
{
    headerNavToggle.addEventListener( "click", ( event ) =>
    {
        event.preventDefault();

        const isOpen = headerOpenNav.classList.toggle( "is-open" );

        if ( headerNavToggleLabel )
        {
            headerNavToggleLabel.textContent = isOpen ? "閉じる" : "メニュー";
        }
    } );
}
